import AuthService from "../login/auth.service";
import { comprobantes, ruedas } from "../../components/generico/utils/UrlAPI";
import axios from "axios";

class ReimpresionRuedaService {

  async reimprimirLista(mesAnho) {
    var config = {
      method: "get",
      url: ruedas + "reimpresion/detalles?mesAnho="+mesAnho,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
    };
    return await axios(config);
  }

  async descargarComprobante(data){

    var _url = comprobantes + "comprobantes/reimpresion/pago-rueda"; 
    var config = {
      method: "POST",
      url: _url,
      data,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
    };
    return await axios(config);
  }

}
export default new ReimpresionRuedaService();
